import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import { MatRadioChange, MatRadioButton } from "@angular/material/radio";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-radio-button",
  templateUrl: "./radio-button.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./radio-button.component.scss"],
  imports: [MatRadioButton, TranslateModule]
})
export class RadioButtonComponent implements OnInit {
  @Output() changeElement: EventEmitter<MatRadioChange> = new EventEmitter();

  @Input() labelPosition: "before" | "after" = "before";
  @Input() titlePath: string;
  @Input() subtitlePath: string;
  @Input() value: string;
  @Input() selected: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
